import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusPipe } from './status.pipe';
import { StatePipe } from './state.pipe';
import { PhoneNumberPipe } from './phone-number-pipe';
import { CompanyNamePipe } from './company-name.pipe';

@NgModule({
  declarations: [
    StatusPipe,
    StatePipe,
    PhoneNumberPipe,
    CompanyNamePipe],
  imports: [
    CommonModule
  ],
  exports: [
    StatusPipe,
    StatePipe,
    PhoneNumberPipe,
    CompanyNamePipe
  ]
})
export class PipesModule { }
